<template>
  <div class="buttons">
    <ButtonComponent
      v-for="button in buttons"
      :key="button.label"
      @buttonClicked="buttonClicked"
      :button="button"
      :theme="selectButtonTheme(button.action)"
      :disabled="isDisabled"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import ButtonComponent from "./Button.vue";
import { button, theme } from "@entersekt/types/build/3-5-0/endpoint";

export default defineComponent({
  name: "ButtonsComponent",
  components: { ButtonComponent },

  data() {
    return {
      isDisabled: false,
    };
  },

  setup() {
    const defaultColor = "#000000";
    return { defaultColor };
  },
  props: {
    buttons: {
      required: true,
      type: Array as PropType<button[]>,
    },
    theme: {
      type: Object as PropType<theme>,
    },
  },

  watch: {
    buttons: {
      handler() {
        this.isDisabled = false;
      },
      deep: true,
    },
  },

  methods: {
    buttonClicked(action: string, actionNext?: string) {
      this.isDisabled = true;
      this.$emit("buttonClicked", this.isDisabled, action, actionNext);
    },

    selectButtonTheme(action: button.action | undefined): string {
      if (!this.theme) {
        return this.defaultColor;
      }
      switch (action) {
        case button.action.CONTINUE: {
          if (this.theme.buttonPrimaryBackgroundColor) {
            return this.theme.buttonPrimaryBackgroundColor;
          }
          break;
        }
        case button.action.CANCEL: {
          if (this.theme.buttonSecondaryBackgroundColor) {
            return this.theme.buttonSecondaryBackgroundColor;
          }
          break;
        }
        case button.action.CANCEL_AND: {
          if (this.theme.buttonTertiaryBackgroundColor) {
            return this.theme.buttonTertiaryBackgroundColor;
          }
          break;
        }
        default: {
          return this.defaultColor;
        }
      }
      return this.defaultColor;
    },
  },

  emits: ["buttonClicked"],
});
</script>

<style scoped>
.buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  column-gap: 20px;
}
</style>
